export const ROLESTYPES = [
  'johnson-employee', // 员工
  'non-goal-doctor', // 非目标EP术者
  'goal-doctor', // 目标EP术者
  'non-ep', // non-ep
  'senior-director', // 大主任
  'senior-director-goal-doctor', // 大主任兼学员
  'lecturer' // 讲师
]

// 判断是否是员工
export let BOOL_EMPLOYEE = ''
// 判断是否是非目标ep术者
export let BOOL_NON_GOAL = ''
// 判断是否是目标ep术者
export let BOOL_GOAL = ''
// 判断是否是non_ep
export let BOOL_NON_EP = ''
// 判断是否是大主任
export let BOOL_SENIOR = ''
// 判断是否是大主任兼学员
export let BOOL_SENIOR_EMPLOYEE = ''
// 判断是否是讲师
export let BOOL_LECTURE = ''

export function handleUpdate(userInfo) {
  BOOL_EMPLOYEE = Object.keys(userInfo).length > 0 ? userInfo.roles[0] === 'johnson-employee' : ''
  BOOL_NON_GOAL = Object.keys(userInfo).length > 0 ? userInfo.roles[0] === 'non-goal-doctor' : ''
  BOOL_GOAL = Object.keys(userInfo).length > 0 ? userInfo.roles[0] === 'goal-doctor' : ''
  BOOL_NON_EP = Object.keys(userInfo).length > 0 ? userInfo.roles[0] === 'non-ep' : ''
  BOOL_SENIOR = Object.keys(userInfo).length > 0 ? userInfo.roles[0] === 'senior-director' : ''
  BOOL_SENIOR_EMPLOYEE = Object.keys(userInfo).length > 0 ? userInfo.roles[0] === 'senior-director-goal-doctor' : ''
  BOOL_LECTURE = Object.keys(userInfo).length > 0 ? userInfo.roles[0] === 'lecturer' : ''
}
// 'PE',
export const PEROLES = ['DPEM', 'PEM', 'CD', 'PSR', 'PD']
export const CDROLES = ['CS']
export const DROLES = ['C', 'D']
export const PREROLES = ['Pre B+', 'Pre A', 'B+', 'A']

export default {
  ROLESTYPES,
  BOOL_EMPLOYEE,
  BOOL_NON_EP,
  BOOL_NON_GOAL,
  BOOL_GOAL,
  BOOL_SENIOR,
  BOOL_SENIOR_EMPLOYEE,
  BOOL_LECTURE,
  handleUpdate,
  PEROLES,
  CDROLES,
  DROLES,
  PREROLES
}



// WEBPACK FOOTER //
// ./src/utils/configRoles.js